(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const quantityButtons = document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]');

    quantityButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const input = this.parentNode.querySelector('.quantity-input__input');
        const currentValue = parseInt(input.value) || 0;

        if (this.hasAttribute('data-quantity-minus')) {
          input.value = Math.max(0, currentValue - 1);
        } else if (this.hasAttribute('data-quantity-plus')) {
          input.value = currentValue + 1;
        }

        // Trigger change event to update totals
        input.dispatchEvent(new Event('change'));
      });
    });

    // Auto-submit on quantity change
    const quantityInputs = document.querySelectorAll('.quantity-input__input');

    quantityInputs.forEach((input) => {
      let timeout;

      input.addEventListener('change', function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.closest('form').submit();
        }, 1000);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["general_header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const menuButton = document.querySelector('.header__icons-menu');
    const menu = document.getElementById('menu');
    const announcement = document.querySelector('.announcement');
    const navHeader = document.querySelector('.nav-header');

    // Function to adjust header and menu position based on announcement height
    function adjustPositions() {
      if (announcement) {
        const announcementHeight = announcement.offsetHeight;
        
        if (navHeader) {
          navHeader.style.top = announcementHeight + 'px';
        }
        
        if (menu) {
          menu.style.setProperty('--dynamic-announcement-height', announcementHeight + 'px');
        }
      }
    }

    // Adjust on load and resize
    if (announcement) {
      adjustPositions();
      window.addEventListener('resize', adjustPositions);
    }

    if (menuButton) {
      menuButton.addEventListener('click', function () {
        if (this.classList.contains('closed')) {
          this.classList.remove('closed');
          this.classList.add('open');
          if (menu) {
            menu.classList.remove('closed');
            menu.classList.add('open');
          }
        } else {
          this.classList.remove('open');
          this.classList.add('closed');
          if (menu) {
            menu.classList.remove('open');
            menu.classList.add('closed');
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_hero"]) return;
  try {
    
  class ScrollingWords extends HTMLElement {
    constructor() {
      super();
      this.words = this.querySelectorAll('.hero__title__scrolling-word');
      this.currentIndex = 0;
      this.interval = 3000;
      this.isPlaying = true;
    }

    connectedCallback() {
      if (this.words.length === 0) return;

      // Show first word initially
      this.words[0].classList.add('active');
      this.words[0].setAttribute('aria-hidden', 'false');

      // Add pause on hover/focus
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      // Start rotation if there's more than one word
      if (this.words.length > 1) {
        this.rotationInterval = setInterval(() => this.rotateWords(), this.interval);
      }
    }

    pause() {
      this.isPlaying = false;
      clearInterval(this.rotationInterval);
    }

    play() {
      if (!this.isPlaying) {
        this.isPlaying = true;
        this.rotationInterval = setInterval(() => this.rotateWords(), this.interval);
      }
    }

    rotateWords() {
      // Remove active class and update ARIA
      this.words[this.currentIndex].classList.remove('active');
      this.words[this.currentIndex].setAttribute('aria-hidden', 'true');

      // Move to next word or back to start
      this.currentIndex = (this.currentIndex + 1) % this.words.length;

      // Add active class and update ARIA
      this.words[this.currentIndex].classList.add('active');
      this.words[this.currentIndex].setAttribute('aria-hidden', 'false');
    }
  }

  customElements.define('scrolling-words', ScrollingWords);

  } catch(e) { console.error(e); }
})();
})();
